<template>
  <right-menu-item
    @click.prevent="click"
    :class="{ 'muted': !isActive }"
    :text="$t('Restore deleted')"
    :loading="loading"
    icon="reload"
    icon-class=""
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import restore from '../../mixins/actions/Restore'
import { trackEvent } from '../../gtm'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    isActive () {
      return true
    },
    ...mapStores(useBcSelectedStore, useBcDocumentStore),
  },
  methods: {
    async click() {
      this.loading = true
      await restore([this.bcDocumentStore.document.id], [])
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'restoreFromTrash')
      await this.$router.replace('/document/' + this.$route.params.rootId + '/' + this.bcDocumentStore.document.id + '/' + this.bcDocumentStore.document.bc_document_rev_id)
    }
  }
}
</script>

<style lang="scss" scoped></style>
